type ShareLinkUrls = Readonly<{ longUrl: string; shortUrl: string | null; shareId: string | null }>;

/**
 * The final, trackable URL info for a single share action.
 *
 * Built by `useShareActions` from a server-provided `ShareLink` — `shareId` present means the
 * server-side shortener resolved it, absent means it didn't (see ShareLink.shareId).
 */
export type ShareUrlInfo = Readonly<{
	url: string;
	trackingProperties: Readonly<{
		generated_share_id: string;
		generated_share_id_source: 'shortener' | 'server_shortener_failure';
	}>;
}>;

/**
 * The URL a share of a server-provided share link sends, and the tracking properties that identify
 * it: the short URL, or the long URL when the server-side shortener returned none. `useShareActions`
 * builds every share action from it. A caller that shares a link outside that pipeline uses it too, so
 * it sends the same URL and the same properties.
 *
 * TODO when legacy logic is removed, we can simplify this to just return `link.shortUrl`
 * and handle the undefined case (shortening failed or wasn't performed) in the getShareActionConfig function
 */
export function getShareUrlInfo(link: ShareLinkUrls): ShareUrlInfo {
	return {
		url: link.shortUrl ?? link.longUrl,
		trackingProperties: {
			generated_share_id: link.shareId ?? '',
			generated_share_id_source: link.shareId ? 'shortener' : 'server_shortener_failure',
		},
	};
}
